import { PublicClientApplication } from '@azure/msal-browser';

export const MicrosoftClientApp = new PublicClientApplication({
  auth: {
    clientId: import.meta.env.REACT_APP_MICROSOFT_CLIENT_ID,
  },
});
